module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./blitz_hover_0000.png").default
        },
        {
            "time": 500,
            "image": require("./blitz_hover_0500.png").default
        },
        {
            "time": 700,
            "image": require("./blitz_hover_0700.png").default
        },
        {
            "time": 900,
            "image": require("./blitz_hover_0900.png").default
        },
        {
            "time": 1100,
            "image": require("./blitz_hover_1100.png").default
        },
        {
            "time": 1700,
            "image": require("./blitz_hover_1700.png").default
        },
        {
            "time": 1900,
            "image": require("./blitz_hover_1900.png").default
        },
    ]
}
